import { Alert, Modal, Typography } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'

const { Paragraph } = Typography

function ShowAuthorizationKeyComponent(props) {
  const { record, ...rest } = props;

  return (
    <Modal
      centered
      title="Get temporary chatbot authorization key"
      okText="OK"
      okButtonProps={{ loading: props.loading }}
      {...rest}
    >
      <div>
        <Paragraph code copyable style={{ marginBottom: '10px' }}>{record.key}</Paragraph>
        <Alert
          message="Sensitive information!"
          description="This is a sensitive information and it will not be visible after you close this screen! Be aware to not share it with anyone."
          type="warning"
          showIcon
        />
      </div>
    </Modal>
  );
}

export const ShowAuthorizationKeyModal = toClass(ShowAuthorizationKeyComponent);

ShowAuthorizationKeyComponent.propTypes = {
  loading: PropTypes.bool,
  record: PropTypes.object
};
